(function() {
    'use strict';

    angular
        .module('itxApp.common')
        .factory('logger', logger);

    logger.$inject = ['ItxConfigurationSvc'];
        
    function logger(ItxConfigurationSvc) {

        /**
         * Configuration options
         */
        var LOG_LEVELS = {
            LOG_NONE: 0,
            LOG_ERROR: 1,
            LOG_ALL: 2
        };

        var valueLogs;
        switch(ItxConfigurationSvc.getEnvironment()){
            case 'DEVELOPMENT':
                valueLogs = LOG_LEVELS.LOG_ALL;
                break;
            case 'PRO':
                valueLogs = LOG_LEVELS.LOG_NONE;
                break;
                // Para todos los entornos mostraremos los logs de error;
            default:
                valueLogs = LOG_LEVELS.LOG_ALL;
                break;
        }
        
        if(!window.config){
            window.config = {
                LOG_LEVEL: valueLogs
            };
        } else {
            window.config.LOG_LEVEL = valueLogs;
        }
       
        var logger = {
            log: log,
            logError: logError
        };
        return logger;

        function log() {
            if (window.config.LOG_LEVEL < LOG_LEVELS.LOG_ALL) {
                return;
            }
            window.type = 'INFO';
            _writeToConsole.apply(window, arguments);
        }

        function logError() {
            if (window.config.LOG_LEVEL < LOG_LEVELS.LOG_ERROR) {
                return;
            }
            window.type = 'ERROR';
            _writeToConsole.apply(window, arguments);
        }

        function _writeToConsole() {
            var d = new Date();
            var i = 0;
            
            if (!console) {
                return;
            }

            // INFO
            var colorLog = 'background:#9AECDB;color:#182C61;font-size:10px';
            try {
                if(window.type == 'ERROR'){
                    // ERROR
                    colorLog = 'background:#FC427B;color:#182C61;font-size:10px';
                }
            } catch (e) {}

            try {
                console.log('%c ' + d.toDateString() + ', seconds: ' + d.getSeconds() + ' ', colorLog );
                console.log.apply(console, arguments);
            } catch (e) {
                for (i = 0; i < arguments.length; i += 1) {
                    console.log(arguments[i]);
                }
            }
        }

    }

})();